import { Component, h, Prop } from '@stencil/core';

@Component({
  tag: 'signet-logo-signet',
})
export class SignetLogoSignet {
  /**
   * Destination of the Logo
   */
  @Prop() href =  "http://design.episource.com";
  
  /**
   * SRC of the logo (Optional)
   */
  @Prop() src =  'https://design.episource.com/img/logo/Product=Signet.svg';

  /**
   * Alternative Text
   */
    @Prop() alt =  'Signet Design System Logo';

  private getLogoLink(): string {
    return ( this.href );
  }

  private getImageLink(): string {
    return ( this.src );
  }


  private getAltText(): string {
    return ( this.alt );
  }

  render() {
    return (
      <a class='signet-logo-signet signet-product-icon' href={this.getLogoLink()}><img src={this.getImageLink()} alt={this.getAltText()} /></a>
    );
  }
}
